import { z } from 'zod';

export const visitSchema = z.object({
  id: z.string(),
  studentId: z.string(),
  visitType: z.enum(['initial', 'followup', 'emergency', 'routine']),
  date: z.string(),
  startTime: z.string(),
  endTime: z.string(),
  familyMembers: z.string(),
  observations: z.string(),
  concerns: z.string().optional(),
  recommendations: z.string(),
  outcome: z.enum(['completed', 'rescheduled', 'noshow', 'cancelled']),
  followUpNeeded: z.boolean(),
  location: z.object({
    address: z.string(),
    latitude: z.number(),
    longitude: z.number()
  })
});

export type Visit = z.infer<typeof visitSchema>;

export const followUpSchema = z.object({
  id: z.string(),
  visitId: z.string(),
  studentId: z.string(),
  action: z.string(),
  dueDate: z.string(),
  status: z.enum(['pending', 'completed', 'overdue']),
  priority: z.enum(['low', 'medium', 'high']),
  notes: z.string().optional()
});

export type FollowUp = z.infer<typeof followUpSchema>;